import { IncentiveOfferType } from 'modules/incentivesMarket/types';

import { IncentiveOffersListProvider } from '../pages/IncentiveOffersList/context/IncentiveOffersListContext';
import IncentiveOffersList from '../pages/IncentiveOffersList';

const IncentiveOffersListContainer = () => (
  <IncentiveOffersListProvider>
    <IncentiveOffersList incentiveOfferType={IncentiveOfferType.BUY} />
  </IncentiveOffersListProvider>
);

export default IncentiveOffersListContainer;
